import {Badge} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import type {UserRelatedAttachmentResponse} from 'src/api/ProactApiClient';
import {AttachmentModuleEnum} from 'src/api/ProactApiClient';
import {ProfileAvatar} from 'src/app/personnel/ProfileAvatar';
import {FormViewDate} from 'src/app/forms/FormViewDate/FormViewDate';
import {FormViewFileListRow} from 'src/app/forms/FormViewFileListRow/FormViewFileListRow';
import {FormViewRow} from 'src/app/forms/FormViewRow/FormViewRow';

const SOURCE_TYPE_LABELS: Partial<
  Record<AttachmentModuleEnum, {label: string; color: string}>
> = {
  [AttachmentModuleEnum.User]: {label: 'Direct', color: 'blue'},
  [AttachmentModuleEnum.CourseAssignment]: {label: 'Training', color: 'green'},
  [AttachmentModuleEnum.ItemAssignment]: {
    label: 'Item Tracker',
    color: 'orange',
  },
  [AttachmentModuleEnum.CourseClassroom]: {
    label: 'Training Classroom',
    color: 'violet',
  },
};

function getSourceBadge(sourceType: AttachmentModuleEnum): {
  label: string;
  color: string;
} {
  return (
    SOURCE_TYPE_LABELS[sourceType] ?? {
      label: AttachmentModuleEnum[sourceType] ?? 'Unknown',
      color: 'gray',
    }
  );
}

export interface UserRelatedAttachmentsListRowProps {
  data: UserRelatedAttachmentResponse;
}

export const UserRelatedAttachmentsListRow = ({
  data,
}: UserRelatedAttachmentsListRowProps) => {
  const badge = getSourceBadge(data.sourceType);

  return (
    <div>
      <Group align="center">
        <ProfileAvatar
          src={data.creatorAvatarUrl}
          alt={data.creatorName ?? ''}
        />
        <div>
          <Group gap="xs" align="center">
            <Badge color={badge.color} variant="light" size="sm">
              {badge.label}
            </Badge>
            {data.sourceLabel && (
              <Text size="sm" fw={500}>
                {data.sourceLabel}
              </Text>
            )}
          </Group>
          <Text size="xs" c="dimmed">
            {data.creatorName ?? '—'} · {data.createdAt.toString().toLongDate()}
          </Text>
        </div>
      </Group>
      <Box pl="xl" pt="sm">
        <Stack gap="xs">
          {data.name && <FormViewRow label="Name" value={data.name} />}
          {data.description && (
            <FormViewRow label="Description" value={data.description} />
          )}
          {data.expiresAt && (
            <FormViewDate label="Expiration Date" value={data.expiresAt} />
          )}
          <FormViewFileListRow label="" value={data.contentUrl} />
        </Stack>
      </Box>
    </div>
  );
};
